import { useAppStore } from '@store'

type Props = {
  closeFn: () => void
}

export function EditorButtons({ closeFn }: Props) {
  const t = useAppStore.use.t()
  const setShouldUpdateCamera = useAppStore.use.setShouldUpdateCamera()
  const closeModal = useAppStore((s) => s.closeModal)

  return (
    <div className='mr-12 mt-auto flex content-end justify-center gap-2 self-end'>
      <button
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          setShouldUpdateCamera(false)
          closeModal()
          closeFn()
        }}
        className='cursor-pointer rounded-sm border border-solid border-C/Color7 bg-C/Color3 px-7 py-0.5 text-xs text-C/Color1'
        type='button'
      >
        {'Ok'}
      </button>
    </div>
  )
}
